import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const ParkAdmin = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [parks, setParks] = useState([]);

  const [analytics, setAnalytics] = useState({});

  const [newTicket, setNewTicket] = useState({
    name: '',
    category: 'entry_ticket',
    price: '',
    description: '',
    validity: { type: 'hours', duration: 3 }
  });

  const [newStaff, setNewStaff] = useState({
    name: '',
    email: '',
    phone: '',
    role: 'ticketing_staff'
  });

  useEffect(() => {
    fetchParks();
    fetchAnalytics();
  }, []);

  const fetchParks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/tickets`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setParks(response.data.tickets);
    } catch (error) {
      console.error('Error fetching parks:', error);
    }
  };

  const fetchAnalytics = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/park-management/parks/analytics`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAnalytics(response.data.analytics);
    } catch (error) {
      console.error('Error fetching analytics:', error);
    }
  };

  const createTicket = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_BASE_URL}/api/park-management/parks/tickets`, newTicket, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNewTicket({ name: '', category: 'entry_ticket', price: '', description: '', validity: { type: 'hours', duration: 3 } });
      fetchParks();
    } catch (error) {
      console.error('Error creating ticket:', error);
    }
  };

  const createStaff = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_BASE_URL}/api/park-management/parks/staff`, newStaff, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNewStaff({ name: '', email: '', phone: '', role: 'ticketing_staff' });
    } catch (error) {
      console.error('Error creating staff:', error);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <header style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', color: 'white', padding: '20px' }}>
        <h1 style={{ margin: 0, fontSize: '24px' }}>🏞️ Park Admin Dashboard</h1>
      </header>

      <div style={{ display: 'flex' }}>
        {/* Sidebar */}
        <nav style={{ width: '250px', background: 'white', minHeight: 'calc(100vh - 80px)', padding: '20px', boxShadow: '2px 0 10px rgba(0,0,0,0.1)' }}>
          {['dashboard', 'tickets', 'staff', 'analytics'].map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                display: 'block',
                width: '100%',
                padding: '12px 16px',
                margin: '8px 0',
                background: activeTab === tab ? '#667eea' : 'transparent',
                color: activeTab === tab ? 'white' : '#4a5568',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                textAlign: 'left',
                fontWeight: '600'
              }}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </nav>

        {/* Main Content */}
        <main style={{ flex: 1, padding: '20px' }}>
          {activeTab === 'dashboard' && (
            <div>
              <h2>📊 Dashboard Overview</h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                  <h3 style={{ color: '#667eea' }}>Total Bookings</h3>
                  <p style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>{analytics.totalBookings || 0}</p>
                </div>
                <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                  <h3 style={{ color: '#48bb78' }}>Total Revenue</h3>
                  <p style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>₹{analytics.totalRevenue || 0}</p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'tickets' && (
            <div>
              <h2>🎫 Ticket Management</h2>
              
              <form onSubmit={createTicket} style={{ background: 'white', padding: '20px', borderRadius: '12px', marginBottom: '20px' }}>
                <h3>Create New Ticket Type</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <input
                    type="text"
                    placeholder="Ticket Name"
                    value={newTicket.name}
                    onChange={(e) => setNewTicket({...newTicket, name: e.target.value})}
                    style={{ padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px' }}
                    required
                  />
                  <select
                    value={newTicket.category}
                    onChange={(e) => setNewTicket({...newTicket, category: e.target.value})}
                    style={{ padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px' }}
                  >
                    <option value="entry_ticket">Entry Ticket</option>
                    <option value="parking_ticket">Parking Ticket</option>
                    <option value="photoshoot_ticket">Photoshoot Ticket</option>
                  </select>
                </div>
                <input
                  type="number"
                  placeholder="Price"
                  value={newTicket.price}
                  onChange={(e) => setNewTicket({...newTicket, price: e.target.value})}
                  style={{ width: '100%', padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px', marginBottom: '16px' }}
                  required
                />
                <textarea
                  placeholder="Description"
                  value={newTicket.description}
                  onChange={(e) => setNewTicket({...newTicket, description: e.target.value})}
                  style={{ width: '100%', padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px', marginBottom: '16px', minHeight: '80px' }}
                />
                <button type="submit" style={{ background: '#667eea', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '8px', cursor: 'pointer' }}>
                  Create Ticket
                </button>
              </form>

              <div style={{ background: 'white', padding: '20px', borderRadius: '12px' }}>
                <h3>Existing Tickets</h3>
                {parks.map(ticket => (
                  <div key={ticket._id} style={{ padding: '16px', border: '1px solid #e2e8f0', borderRadius: '8px', marginBottom: '12px' }}>
                    <h4>{ticket.name}</h4>
                    <p>Category: {ticket.category} | Price: ₹{ticket.price}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'staff' && (
            <div>
              <h2>👥 Staff Management</h2>
              
              <form onSubmit={createStaff} style={{ background: 'white', padding: '20px', borderRadius: '12px', marginBottom: '20px' }}>
                <h3>Add New Staff Member</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <input
                    type="text"
                    placeholder="Full Name"
                    value={newStaff.name}
                    onChange={(e) => setNewStaff({...newStaff, name: e.target.value})}
                    style={{ padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px' }}
                    required
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    value={newStaff.email}
                    onChange={(e) => setNewStaff({...newStaff, email: e.target.value})}
                    style={{ padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px' }}
                    required
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <input
                    type="tel"
                    placeholder="Phone"
                    value={newStaff.phone}
                    onChange={(e) => setNewStaff({...newStaff, phone: e.target.value})}
                    style={{ padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px' }}
                  />
                  <select
                    value={newStaff.role}
                    onChange={(e) => setNewStaff({...newStaff, role: e.target.value})}
                    style={{ padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px' }}
                  >
                    <option value="manager">Manager</option>
                    <option value="ticketing_staff">Ticketing Staff</option>
                    <option value="security">Security</option>
                  </select>
                </div>
                <button type="submit" style={{ background: '#667eea', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '8px', cursor: 'pointer' }}>
                  Add Staff Member
                </button>
              </form>
            </div>
          )}

          {activeTab === 'analytics' && (
            <div>
              <h2>📈 Analytics</h2>
              <div style={{ background: 'white', padding: '20px', borderRadius: '12px' }}>
                <h3>Booking Statistics</h3>
                <p>Total Bookings: {analytics.totalBookings || 0}</p>
                <p>Total Revenue: ₹{analytics.totalRevenue || 0}</p>
                
                {analytics.statusBreakdown && (
                  <div style={{ marginTop: '20px' }}>
                    <h4>Status Breakdown:</h4>
                    {Object.entries(analytics.statusBreakdown).map(([status, count]) => (
                      <p key={status}>{status}: {count}</p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default ParkAdmin;